import { create } from 'zustand'

interface searchOptions {
  page: number;
  perPage: number;
  search: string;
  role: string;
  status: string;
}

interface PermissionsStore {
  searchOptions: searchOptions;
  updateSearchOptions: (data: Partial<searchOptions>) => void;
}

const usePermissionsStore = create<PermissionsStore>()(
  set => ({
    searchOptions: {
      page: 0,
      perPage: 50,
      search: '',
      role: '',
      status: ''
    },
    updateSearchOptions: data => {
      set(state => ({ searchOptions: {
        ...state.searchOptions,
        page: 0,
        ...data
      } }))
    }
  })
)

export default usePermissionsStore
